"use client";
// import { ResumeData } from "@/lib/schema";

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// export default function Modern({ data }: { data: ResumeData }) {
//   return (
//     <div className="p-8 font-sans bg-gray-50">
//       {/* Header */}
//       <div className="border-b pb-4 mb-6 border-black">
//         <h1 className="text-4xl font-extrabold text-blue-600">{data.basics.name}</h1>
//         <p className="text-lg text-gray-700">{data.basics.title}</p>
//         <p className="text-sm text-gray-500">
//           {data.basics.email} | {data.basics.phone}{data.basics.location ? ` | ${data.basics.location}` : ''}
//         </p>
//       </div>

//       {/* Summary */}
//       {data.basics.summary && (
//         <div className="mb-6">
//           <h2 className="text-xl font-bold text-blue-600">Summary</h2>
//           <p className="mt-2 text-gray-700">{data.basics.summary}</p>
//         </div>
//       )}

//       {/* Experience */}
//       {data.experience.length > 0 && (
//         <div className="mb-6">
//           <h2 className="text-xl font-bold text-blue-600">Experience</h2>
//           {data.experience.map((exp, i) => (
//             <div key={i} className="mt-3">
//               <p className="font-semibold text-gray-800">
//                 {exp.role} — {exp.company}
//               </p>
//               <p className="text-xs text-gray-500">
//                 {exp.startDate} - {exp.current ? 'Present' : exp.endDate}
//               </p>
//               {exp.summary && (
//                 <p className="mt-1 text-gray-700 text-sm">{exp.summary}</p>
//               )}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Education */}
//       {data.education.length > 0 && (
//         <div className="mb-6">
//           <h2 className="text-xl font-bold text-blue-600">Education</h2>
//           {data.education.map((edu, i) => (
//             <div key={i} className="mt-2">
//               <p className="font-semibold text-gray-800">
//                 {edu.degree} — {edu.institution}
//               </p>
//               <p className="text-xs text-gray-500">
//                 {edu.startDate} - {edu.endDate}
//               </p>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Skills */}
//       {data.skills.length > 0 && (
//         <div>
//           <h2 className="text-xl font-bold text-blue-600">Skills</h2>
//           <div className="flex flex-wrap gap-2 mt-2">
//             {data.skills.map((skill, i) => (
//               <span
//                 key={i}
//                 className="bg-blue-100 text-blue-700 text-sm px-2 py-1 rounded"
//               >
//                 {skill}
//               </span>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Strengths Section - Only show if data exists */}
//       {data.basics.strengths && data.basics.strengths.length > 0 && (
//         <div className="mt-6">
//           <h2 className="text-xl font-bold text-blue-600">Strengths</h2>
//           <div className="space-y-3 mt-2">
//             {data.basics.strengths.map((strength, i) => (
//               <div key={i}>
//                 <p className="font-semibold text-gray-800">{strength.title}</p>
//                 {strength.description && (
//                   <p className="text-sm text-gray-600">{strength.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Key Achievements Section - Only show if data exists */}
//       {data.basics.achievements && data.basics.achievements.length > 0 && (
//         <div className="mt-6">
//           <h2 className="text-xl font-bold text-blue-600">Key Achievements</h2>
//           <div className="space-y-3 mt-2">
//             {data.basics.achievements.map((achievement, i) => (
//               <div key={i}>
//                 <p className="font-semibold text-gray-800">{achievement.title}</p>
//                 {achievement.description && (
//                   <p className="text-sm text-gray-600">{achievement.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//       {data.basics.languages && data.basics.languages.length > 0 && (
//         <div className="mt-6">
//           <h2 className="text-xl font-bold text-blue-600">Languages</h2>
//           <p className="mt-2 text-gray-700">
//             {Array.isArray(data.basics.languages)
//               ? data.basics.languages
//                   .map((lang) => getLanguageName(lang as string | { name: string }))
//                   .join(", ")
//               : ""}
//           </p>
//         </div>
//       )}
//       {data.basics.social && data.basics.social.length > 0 && (
//         <div className="mt-6">
//           <h2 className="text-xl font-bold text-blue-600">Social Links</h2>
//           <ul>
//             {data.basics.social.map((link, i) => (
//               <li key={i}><span className=" text-gray-700">{link.label}:</span> <a href={link.url} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">{link.url}</a></li>
//             ))}
//           </ul>
//         </div>
//       )}
//       {data.basics.hobbies && data.basics.hobbies.length > 0 && (
//         <div className="mt-6">
//           <h2 className="text-xl font-bold text-blue-600">Hobbies & Interests</h2>
//           <div className="flex flex-wrap gap-2 mt-2">
//             {data.basics.hobbies.map((hobby, i) => (
//               <span
//                 key={i}
//                 className="bg-purple-100 text-purple-700 text-sm px-2 py-1 rounded"
//               >
//                 {hobby}
//               </span>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import { ResumeData } from "@/lib/schema";

const getLanguageName = (lang: string | { name: string }): string =>
  typeof lang === "string" ? lang : lang.name;

const sectionTitleStyle = {
  fontSize: "20px",
  fontWeight: "bold",
  color: "#2563eb",
  marginBottom: "10px",
  marginTop: "18px",
};

const mainDivStyle = {
  padding: "32px",
  fontFamily: "sans-serif",
  backgroundColor: "#f9fafb",
  color: "#18181b",
};

const headerDivStyle = {
  borderBottom: "2px solid #000",
  paddingBottom: "16px",
  marginBottom: "24px",
};

const nameStyle = {
  fontSize: "32px",
  fontWeight: "800",
  color: "#2563eb",
  marginBottom: "4px",
};

const titleStyle = {
  fontSize: "18px",
  color: "#334155",
  marginBottom: "6px",
};

const contactStyle = {
  fontSize: "15px",
  color: "#6b7280",
};

const summaryStyle = {
  marginBottom: "24px",
};

const jobHeaderStyle = {
  fontWeight: 600,
  color: "#242424",
};

const dateStyle = {
  fontSize: "12px",
  color: "#6b7280",
};

const jobSummaryStyle = {
  marginTop: "4px",
  color: "#404040",
  fontSize: "14px",
};

const skillItemStyle = {
  backgroundColor: "#dbeafe",
  color: "#2563eb",
  fontSize: "14px",
  padding: "4px 8px",
  borderRadius: "6px",
  display: "inline-block",
  marginRight: "6px",
  marginBottom: "6px",
};

const hobbyItemStyle = {
  backgroundColor: "#ede9fe",
  color: "#6d28d9",
  fontSize: "14px",
  padding: "4px 8px",
  borderRadius: "6px",
  display: "inline-block",
  marginRight: "6px",
  marginBottom: "6px",
};

const strengthTitleStyle = {
  fontWeight: 600,
  color: "#242424",
};

const strengthDescStyle = {
  fontSize: "13px",
  color: "#525252",
};

const achievementTitleStyle = {
  fontWeight: 600,
  color: "#242424",
};

const achievementDescStyle = {
  fontSize: "13px",
  color: "#525252",
};

const socialLinkStyle = {
  color: "#2563eb",
  textDecoration: "underline",
};

export default function Modern({ data }: { data: ResumeData }) {
  return (
    <div style={mainDivStyle}>
      {/* Header */}
      <div style={headerDivStyle}>
        <h1 style={nameStyle}>{data.basics.name}</h1>
        <p style={titleStyle}>{data.basics.title}</p>
        <p style={contactStyle}>
          {data.basics.email} | {data.basics.phone}
          {data.basics.location ? ` | ${data.basics.location}` : ""}
        </p>
      </div>

      {/* Summary */}
      {data.basics.summary && (
        <div style={summaryStyle}>
          <h2 style={sectionTitleStyle}>Summary</h2>
          <p style={{ marginTop: "6px", color: "#404040" }}>
            {data.basics.summary}
          </p>
        </div>
      )}

      {/* Experience */}
      {data.experience.length > 0 && (
        <div style={{ marginBottom: "24px" }}>
          <h2 style={sectionTitleStyle}>Experience</h2>
          {data.experience.map((exp, i) => (
            <div key={i} style={{ marginTop: "10px" }}>
              <p style={jobHeaderStyle}>
                {exp.role} — {exp.company}
              </p>
              <p style={dateStyle}>
                {exp.startDate} - {exp.current ? "Present" : exp.endDate}
              </p>
              {exp.summary && (
                <p style={jobSummaryStyle}>{exp.summary}</p>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Education */}
      {data.education.length > 0 && (
        <div style={{ marginBottom: "24px" }}>
          <h2 style={sectionTitleStyle}>Education</h2>
          {data.education.map((edu, i) => (
            <div key={i} style={{ marginTop: "10px" }}>
              <p style={jobHeaderStyle}>
                {edu.degree} — {edu.institution}
              </p>
              <p style={dateStyle}>
                {edu.startDate} - {edu.endDate}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Skills */}
      {data.skills.length > 0 && (
        <div>
          <h2 style={sectionTitleStyle}>Skills</h2>
          <div style={{ marginTop: "8px", marginBottom: "16px" }}>
            {data.skills.map((skill, i) => (
              <span key={i} style={skillItemStyle}>
                {skill}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Strengths */}
      {data.basics.strengths && data.basics.strengths.length > 0 && (
        <div style={{ marginTop: "24px" }}>
          <h2 style={sectionTitleStyle}>Strengths</h2>
          <div>
            {data.basics.strengths.map((strength, i) => (
              <div key={i} style={{ marginTop: "8px" }}>
                <p style={strengthTitleStyle}>{strength.title}</p>
                {strength.description && (
                  <p style={strengthDescStyle}>{strength.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Achievements */}
      {data.basics.achievements && data.basics.achievements.length > 0 && (
        <div style={{ marginTop: "24px" }}>
          <h2 style={sectionTitleStyle}>Key Achievements</h2>
          <div>
            {data.basics.achievements.map((achievement, i) => (
              <div key={i} style={{ marginTop: "8px" }}>
                <p style={achievementTitleStyle}>{achievement.title}</p>
                {achievement.description && (
                  <p style={achievementDescStyle}>
                    {achievement.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Languages */}
      {data.basics.languages && data.basics.languages.length > 0 && (
        <div style={{ marginTop: "24px" }}>
          <h2 style={sectionTitleStyle}>Languages</h2>
          <p style={{ marginTop: "8px", color: "#404040" }}>
            {Array.isArray(data.basics.languages)
              ? data.basics.languages
                  .map((lang) =>
                    getLanguageName(lang as string | { name: string })
                  )
                  .join(", ")
              : ""}
          </p>
        </div>
      )}

      {/* Social Links */}
      {data.basics.social && data.basics.social.length > 0 && (
        <div style={{ marginTop: "24px" }}>
          <h2 style={sectionTitleStyle}>Social Links</h2>
          <ul style={{ paddingLeft: "0", marginTop: "8px" }}>
            {data.basics.social.map((link, i) => (
              <li key={i} style={{ listStyleType: "none", marginBottom: "6px" }}>
                <span style={{ color: "#404040" }}>{link.label}: </span>
                <a
                  href={link.url}
                  style={socialLinkStyle}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.url}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Hobbies & Interests */}
      {data.basics.hobbies && data.basics.hobbies.length > 0 && (
        <div style={{ marginTop: "24px" }}>
          <h2 style={sectionTitleStyle}>Hobbies & Interests</h2>
          <div style={{ marginTop: "8px" }}>
            {data.basics.hobbies.map((hobby, i) => (
              <span key={i} style={hobbyItemStyle}>
                {hobby}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
